module.exports = __webpack_public_path__ + "static/media/male-mechanic_1f468-200d-1f527.d79e3f70.png";